import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';

const QuoteTabBarLoadingState: React.FC = () => {
  return (
    <section className="bg-loading/background-1">
      {/*-- mobile --*/}
      <div className="h-32 flex items-center justify-center md:hidden">
        <div className="space-y-3">
          <div className="w-[50px] h-8 bg-loading/background-2 rounded-full" />
          <div className="w-[125px] h-4 bg-loading/background-2 rounded-default" />
        </div>
      </div>

      {/*-- tablet and desktop --*/}
      <div className="hidden md:block">
        <Container startingBreakpoint="lg">
          <Grid className="h-32" gapX="gap-x-0">
            {['loading-column-1', 'loading-column-2', 'loading-column-3'].map(
              (loadingColumnId: string) => (
                <Col span={{ default: 4 }} key={loadingColumnId}>
                  <div className="h-full flex items-center justify-center">
                    <div className="flex flex-col items-center justify-center space-y-3">
                      <div className="w-8 h-8 bg-loading/background-2 rounded-full" />
                      <div className="w-[125px] h-4 bg-loading/background-2 rounded-default" />
                    </div>
                  </div>
                </Col>
              )
            )}
          </Grid>
        </Container>
      </div>
    </section>
  );
};

export default memo(withBlokWrapper(QuoteTabBarLoadingState, Theme.LIGHT));
